export function generateFilename(base = 'file') {
  const now = new Date();

  const localDate = now.toLocaleDateString('sv-SE'); // YYYY-MM-DD
  const localTime = now.toLocaleTimeString('sv-SE', { hour12: false }); // HH:mm:ss

  const formattedTime = localTime.replace(/:/g, '-');

  return `${base}_${localDate}_${formattedTime}`;
}

export const isEmailValid = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);